import { render } from "./Pelarasan.vue?vue&type=template&id=ae4afa44"
import script from "./Pelarasan.vue?vue&type=script&lang=js"
export * from "./Pelarasan.vue?vue&type=script&lang=js"

import "./Pelarasan.vue?vue&type=style&index=0&id=ae4afa44&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__